import { Injectable } from '@angular/core';
import { SeverityLevel } from "@microsoft/applicationinsights-web";
import { MonitoringService } from "./monitoring.service";
import { environment } from "../../environments/environment";

@Injectable({
  providedIn: 'root'
})
/**
 * Logs application traces.
 */
export class LoggingService {

  constructor(
    private monitoring: MonitoringService
  ) {
  }

  logVerbose(message: string, properties?: { [key: string]: unknown }) {
    this.monitoring.logTrace(message, properties, SeverityLevel.Verbose);
    console.debug(message, properties);
  }

  logInformation(message: string, properties?: { [key: string]: unknown }) {
    this.monitoring.logTrace(message, properties, SeverityLevel.Information);
    console.info(message, properties);
  }

  logWarning(message: string, properties?: { [key: string]: unknown }) {
    this.monitoring.logTrace(message, properties, SeverityLevel.Warning);
    console.warn(message, properties);
  }

  logError(message: string, exception?: Error, properties?: { [key: string]: unknown }) {
    this.monitoring.logTrace(message, properties, SeverityLevel.Error);
    console.error(message, exception, properties);

    if (exception != null) {
      this.monitoring.logException(exception, properties);
    }
  }

  logCritical(message: string, exception?: Error, properties?: { [key: string]: unknown }) {
    this.monitoring.logTrace(message, properties, SeverityLevel.Critical);
    console.error(message, exception, properties);

    if (exception != null) {
      this.monitoring.logException(exception, properties);
    }
  }
}
